import { defineMessage } from 'services/localization';

export const messages = {
    amountGross: defineMessage('amount_gross_1'),
    PONumber: defineMessage('po_number'),
    amountFromText: defineMessage('from_1'),
    amountToText: defineMessage('to_1'),
    showOnlyMatched: defineMessage('show_only_matched_pos'),
    dateRange: defineMessage('date_range'),
    dateFromText: defineMessage('from_1'),
    dateToText: defineMessage('to_1'),
    clearButtonText: defineMessage('clear_1'),
    filterButtonText: defineMessage('filter_1'),
    sectionTitle: defineMessage('filter'),
    enterTheAmount: defineMessage('enter_the_amount'),
    enterTheDate: defineMessage('enter_the_date'),
    enterNumber: defineMessage('enter_the_number'),
    clearFilterValues: defineMessage('clear_filter_values'),
    applyFilter: defineMessage('apply_filter'),
};
